export default __webpack_public_path__ + "252cd46fabba87d04e9daa5467a00ebf.png";